var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_282_293",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_282_293)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40001 2.3999C9.06274 2.3999 9.60001 2.93716 9.60001 3.5999V4.7999H10.4787C10.4928 4.79965 10.507 4.79965 10.5212 4.7999H13.2C13.8627 4.7999 14.4 5.33717 14.4 5.9999C14.4 6.66264 13.8627 7.1999 13.2 7.1999H11.4936C11.0596 9.22488 10.3569 11.1498 9.42485 12.9355C9.77377 13.3605 10.1396 13.7711 10.5212 14.1665C10.9815 14.6433 10.9681 15.403 10.4913 15.8633C10.0144 16.3235 9.25477 16.3102 8.79449 15.8333C8.56756 15.5982 8.34562 15.3583 8.12886 15.1137C7.06674 16.692 5.81263 18.13 4.40029 19.3941C3.90646 19.836 3.14782 19.794 2.70583 19.3002C2.26384 18.8063 2.30589 18.0477 2.79973 17.6057C4.25544 16.3029 5.52258 14.7945 6.55573 13.1266C5.88797 12.1798 5.29039 11.1797 4.77067 10.1339C4.47574 9.54044 4.71778 8.82023 5.31127 8.52529C5.90477 8.23034 6.62499 8.47237 6.91993 9.06587C7.20025 9.62993 7.50594 10.1792 7.83553 10.7123C8.3364 9.59117 8.73897 8.41673 9.03238 7.1999H3.60001C2.93727 7.1999 2.40001 6.66264 2.40001 5.9999C2.40001 5.33717 2.93727 4.7999 3.60001 4.7999H7.20001V3.5999C7.20001 2.93716 7.73726 2.3999 8.40001 2.3999ZM15.6 9.5999C16.0546 9.5999 16.47 9.8567 16.6733 10.2633L20.2625 17.4417C20.2703 17.4564 20.2778 17.4714 20.2849 17.4865L21.4733 19.8633C21.7697 20.4561 21.5295 21.1768 20.9367 21.4732C20.3439 21.7696 19.6231 21.5293 19.3267 20.9365L18.4584 19.1999H12.7417L11.8733 20.9365C11.5769 21.5293 10.8561 21.7696 10.2634 21.4732C9.67059 21.1768 9.43029 20.4561 9.72668 19.8633L10.9151 17.4865C10.9222 17.4714 10.9297 17.4564 10.9375 17.4417L14.5267 10.2633C14.73 9.8567 15.1454 9.5999 15.6 9.5999ZM13.9417 16.7999H17.2584L15.6 13.4832L13.9417 16.7999Z",
    fill: "#FFB829"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLanguage);
export default __webpack_public_path__ + "static/media/Change-Language.0a47f3ac9d8e2d687af78864bfd31679.svg";
export { ForwardRef as ReactComponent };